import React, { useReducer } from 'react';
import SubstatusContext from './substatusContext';
import SubstatusReducer from './substatusReducer';
import api from '../../api/api';
import {
    GET_SUBSTATUSES,
    GET_SUBSTATUS,
    CREATE_SUBSTATUS,
    DELETE_SUBSTATUS,
    UPDATE_SUBSTATUS,
    CLEAR_STATE,
    SET_LOADING,
} from '../types';
import { HEADERS } from '../../constants/headers';
import { handleError } from '../utils/handleError';

const SubstatusState = (props) => {
    const initialState = {
        substatuses: [],
        substatus: {},
        loading: false,
        error: null,
    };

    const [state, dispatch] = useReducer(SubstatusReducer, initialState);

    const getSubstatusesByStatus = async (statusId) => {
        clearSubstatusState();
        setLoading();
        try {
            const res = await api.get(
                `/status/${statusId}/substatus?sort=name`,
                HEADERS()
            );
            dispatch({ type: GET_SUBSTATUSES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Substatuses
    const getSubstatuses = async () => {
        clearSubstatusState();
        setLoading();
        try {
            const res = await api.get(`/substatus?sort=name`, HEADERS());
            dispatch({ type: GET_SUBSTATUSES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Substatus
    const getSubstatus = async (substatusId) => {
        clearSubstatusState();
        setLoading();
        try {
            const res = await api.get(`/substatus/${substatusId}`, HEADERS());
            dispatch({ type: GET_SUBSTATUS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Create Substatus
    const createSubstatus = async (substatus, status) => {
        clearSubstatusState();
        setLoading();
        try {
            const res = await api.post(
                `/status/${status}/substatus`,
                { ...substatus },
                HEADERS()
            );
            dispatch({ type: CREATE_SUBSTATUS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Delete Substatus
    const deleteSubstatus = async (substatusId) => {
        setLoading();
        try {
            const res = await api.delete(
                `/substatus/${substatusId}`,
                HEADERS()
            );
            dispatch({ type: DELETE_SUBSTATUS, payload: res.data.deletedId });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Update Substatus
    const updateSubstatus = async (substatus, substatusId) => {
        clearSubstatusState();
        setLoading();

        try {
            const res = await api.put(
                `/substatus/${substatusId}`,
                { ...substatus },
                HEADERS()
            );
            dispatch({ type: UPDATE_SUBSTATUS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Clear State
    const clearSubstatusState = () => dispatch({ type: CLEAR_STATE });

    //Set Loading
    const setLoading = () => dispatch({ type: SET_LOADING });

    return (
        <SubstatusContext.Provider
            value={{
                loading: state.loading,
                substatuses: state.substatuses,
                substatus: state.substatus,
                error: state.error,
                getSubstatuses,
                createSubstatus,
                getSubstatus,
                deleteSubstatus,
                updateSubstatus,
                getSubstatusesByStatus,
                setLoading,
                clearSubstatusState,
            }}
        >
            {props.children}
        </SubstatusContext.Provider>
    );
};

export default SubstatusState;
